export const occupationTypes: { id: string; name: string; }[] = [
  {
    id: 'doctor',
    name: 'doctor',
  },
  {
    id: 'physio',
    name: 'physio',
  },
  {
    id: 'rehabilitator',
    name: 'rehabilitator',
  },
];